import { Link } from "react-router-dom";
import { ArrowUpRight, Settings } from "lucide-react";
import { ROUTES } from "@/constants/routes";

export default function SettingsHome() {
  return (
    <section data-testid="settings-page" className="mw-rise">
      <p className="mw-eyebrow">Settings</p>
      <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl">Account settings.</h1>
      <Link to={ROUTES.profileEditor} data-testid="settings-edit-identity-link" className="group mt-10 flex items-center justify-between gap-6 rounded-lg border border-border bg-card p-6 transition-colors hover:border-foreground/40 sm:p-8">
        <div>
          <p className="font-serif text-2xl tracking-tight">Professional identity</p>
          <p className="mt-2 text-sm text-muted-foreground">Name, title, contact details, bio, links, photo and logo.</p>
        </div>
        <ArrowUpRight className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </Link>
      <div data-testid="coming-next-empty-state" className="mt-6 flex items-start gap-4 rounded-lg border border-dashed border-border px-6 py-6 sm:px-8">
        <Settings className="mt-0.5 h-5 w-5 text-gold" aria-hidden="true" />
        <div>
          <p className="mw-eyebrow">Coming next</p>
          <p className="mt-2 text-sm text-foreground/80">Password, email preferences and data export.</p>
        </div>
      </div>
    </section>
  );
}
